import type { FC, PropsWithChildren } from 'react'

const SessionPreview: FC<PropsWithChildren> = ({ children }) => children

export default SessionPreview
